import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import {  message,Select   } from 'antd';

import Foot from '../../components/foot/Foot'
import NumberFormat from 'react-number-format'


import { useTranslation } from 'react-i18next'

import './tan.css'
import {getLiushuiBcbse} from "../../api";

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexMeba = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [classesList,setClassesList]=useState([])
    const [page,setPage]=useState(1)


    const _getNewClassess = (e) =>{

         _getLiushuiCcer(e)
    }


    const _getLiushuiCcer = (c) =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getLiushuiBcbse({classes:c,page:page}).then(res=>{
            if(res.code === 0 ){

                if(res.data.classesList != null){
                    setClassesList(res.data.classesList)
                }


                    setList(res.data.list || [])


            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }





    useEffect(() => {
            window.scrollTo(0, 0)
            _getLiushuiCcer(999)
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            
            <div style={{"backgroundColor":"#000628"}} className='  w-full lg:w-1/3 pb-20  pt-20 text-white flex flex-col z-10'>
                <div className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                            <div  className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                            <img onClick={()=>window.history.back()} alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                            <span className='text-2xl oblod text-gray-100'>{t('r.历史记录')} BCBSE</span>
                            </div>
                        
                        </div>

                {/*  */}
                <div className=' bg-[#000F3A] mt-5 mx-4 px-4 pt-6 pb-6 rounded-xl flex flex-col items-start border border-[#0161F6]'>
                    
                  
                    <div className='w-full mb-4'>
                        <Select
                        size='large'
                            defaultValue="所有类型"
                            style={{
                                width: "100%"
                            }}
                            onChange={_getLiushuiCcer}
                            options={classesList}
                            />
                    </div>
                    <span className='mb-3 text-xs text-[#0042bd] fontM'>No data</span>
                    <div className=' w-full h-[1px] bg-[#0161F6]'></div>
                    {/*  */}
                                        {
                                            list.length>0?
                                                list.map((item,index)=> {
                                                    return (
                                                        <>
                                                            <div className='mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                                                <div className=' w-full flex flex-row justify-between items-center'>
                                                                    <div className=' text-gray-500 text-xs flex flex-row'>
                                                                        <span>{item.classname}</span>
                                                                    </div>
                                                                    <div className=' text-gray-500 text-xs flex flex-row'>
                                                                        <img alt='rr' className=' mr-1' src={require('../../assets/bcb/logo.png')} style={{"width":"15px"}}></img>
                                                                        {
                                                                            item.value>0?(
                                                                                <span className='text-green-500'>+<NumberFormat
                                                                                                thousandsGroupStyle="thousand"
                                                                                                value={item.value}
                                                                                                prefix=""
                                                                                                decimalSeparator="."
                                                                                                displayType="text"
                                                                                                type="text"
                                                                                                thousandSeparator={true}
                                                                                                allowNegative={false}
                                                                                                decimalScale={6} /></span>
                                                                            ):(
                                                                                <span className='text-red-500'>-<NumberFormat
                                                                                                thousandsGroupStyle="thousand"
                                                                                                value={item.value}
                                                                                                prefix=""
                                                                                                decimalSeparator="."
                                                                                                displayType="text"
                                                                                                type="text"
                                                                                                thousandSeparator={true}
                                                                                                allowNegative={false}
                                                                                                decimalScale={6} /></span>
                                                                            )
                                                                        }
                                                                        
                                                                    </div>
                                                                    
                                                                </div>
                                                                <div className='mt-2 w-full flex flex-row justify-between items-center'>
                                                                    <div className=' text-gray-500 text-xs flex flex-row'>
                                                                        
                                                                        <span>MEMO.</span>
                                                                    </div>
                                                                    <span className='text-xs text-gray-300 block'>{item.add_time}</span>
                                                                </div>
                                                                
                                                            </div>
                                                            <div className=' w-full h-[1px] my-2 bg-[#0161F6]'></div>
                                                        </>
                                                    )
                                                }):(
                                                    <div  className=' w-full  py-32 flex flex-row items-center justify-center text-gray-200 text-xs'>
                                                        No data
                                                    </div>
                                                )
                                        }
                                        
                                        {/*  */}
                    
                    
                </div>
                {/*  */}

                {/* people */}
               



            </div>
          
           

        <Foot/> 
        </>
    );
}

export default connect(mapStateToProps)(IndexMeba);
